<template>
    <div class="toast_wrap" :style="{ opacity: $GlobalStore.isShowToast() ? 1 : 0, top: $GlobalStore.isShowToast() ? '' : '100%' }">
        <div v-html="$GlobalStore.toastStr()" style="line-height:16px; font-weight: 400;"></div>
    </div>
</template>

<script>
export default {
    name: "toast",
}
</script>

<style scoped>
.toast_wrap {
    position: fixed;
    background: #210F03E5;
    color: white;
    bottom: 140px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 1s;
    padding: 16px;
    border-radius: 12px;
    font-size: 12px;
    width: 80%;
    text-align: center;
}
</style>